<template>

    <div class="card blue lighten-4">
      <div class="card-content">
        <h4 class="card-title" style="margin-bottom: 16px">
          <span>Persone nel gruppo</span>
          <!--        <button class="btn modal-trigger" data-target="new_person_modal">Aggiungi</button>-->
          <a class="btn"
             style="float:right"
             :href="createEnabled ? 'index.php?option=com_asdgest&view=person&returnpath=dashboard&layout=new' : '#'">Aggiungi</a>
        </h4>

        <p>Ci sono {{persons.length}} persone, di cui amministratori: {{ assignedAdmins }} su 3</p>

        <ul class="collection">
          <li
              v-for="person in persons"
              :key="person.person_id"
              class="collection-item avatar"
          >
            <img :src="profileImage(person.image_profile)" :alt="'Foto di '+person.surname+' '+person.name" class="circle">
            <span class="title">
              <span>{{ person.surname }} {{ person.name }}</span>
              <span class="new badge id grey darken-2 nonew">{{ person.person_id }}</span>
              <span v-if="isAdmin(person.person_id)" class="new nonew badge deep-purple darken-4">Amministratore</span>
            </span>
            <div>
              <p>Percentuale inserimento dati obbligatori: <span v-html="calcPerc(person)"/>%</p>
              <div class="progress">
                <div :class="{
                  'determinate': true,
                  'red': calcPerc(person) < 100
                }" :style="'width:'+ calcPerc(person) +'%'"></div>
                }
              </div>
            </div>
            <span v-if="person.user_id === 0" class="badge new nonew yellow">Nessun utente creato</span>
            <span v-else-if="person.user_id < 0" class="badge new nonew red">Errore creazione utente</span>
            <span v-else>
              <span v-if="person.activation !== ''" class="badge new nonew orange">Utente mai attivato</span>
              <span v-if="parseInt(person.block) === 1" class="badge new nonew red">Utente bloccato</span>
              <span v-if="parseInt(person.block) !== 1 && person.activation === ''" class="badge new nonew green">Utente ok</span>
            </span>
            <span v-if="person.chat_id > 0" class="badge new nonew blue">Telegram attivo</span>
            <p><strong>email:</strong> {{person.email}}</p>
            <p><strong>username:</strong> {{person.username}}</p>
            <a class="secondary-content"
               :href="'/index.php?option=com_asdgest&view=person&layout=edit&returnpath=dashboard&person_id='+person.person_id"><i
                class="material-icons">edit</i></a>
          </li>
        </ul>

      </div>

      <div class="modal modal-fixed-footer" id="new_person_modal">
        <div v-if="createEnabled" class="modal-content">
          <p>form di creazione</p>
        </div>
        <div v-else class="modal-content"
             style="display: flex; flex-direction: column; align-content: center; justify-content: center; text-align: center !important">
          <p>Non puoi aggiungere persone fino a che i dati del gruppo non sono completi.</p>
          <p>
            <button class="btn red modal-close">Ho capito, chiudi questo box</button>
          </p>
        </div>
        <div class="modal-footer" v-if="createEnabled">
          <button class="btn red modal-close">Annulla</button>
          <button class="btn green">Crea</button>
        </div>
      </div>


    </div>


</template>

<script>

import Vue from 'vue';
import axios from 'axios';
import adaptProfileImage from './../../vue/mixins/adaptProfileImage.js';

export default {
  name: "GroupPersons",
  props: {
    groupId: {
      required: true,
      type: Number
    },
    createEnabled: {
      required: true,
      type: Boolean,
    },
    groupData: {
      required: true,
      type: Object
    },
    persons: {
      required: true,
      type: Array
    },
    admins: {
      required: true,
      type: Array
    },
    fields: {
      required: true,
      type: Array
    }
  },

  data: () => {
    return {
      edit: 0,
      newPersonModal: false,
      changeRoleCommand: null,
    }
  },

  methods: {
    calcPerc: function (person) {
      let filled = 0;
      for (let field of this.fields) {
        if (field.required) {
          if (Object.prototype.hasOwnProperty.call(person, field.fieldname) && person[field.fieldname] !== '') {
            filled++;
          }
        }
      }
      // console.log('confronting', person, this.fields, filled, this.required);
      return Math.floor(filled / this.required * 100);
    },

    profileImage: function (image) {
      if (image === '') {
        return '/media/com_asdgest/images/placeholder/profile.png';
      }
      const returned = adaptProfileImage(image);
      return returned !== '' ? returned : '/media/com_asdgest/images/placeholder/profile.png';
    },

    isAdmin(person_id) {
      return this.adminsIds.find(x => x === person_id) !== undefined;
    },
  },

  computed: {

    adminsIds: function () {
      let ret = [];
      for (let admin of this.admins) {
        if (admin.person_id > 0) {
          const person = this.persons.find((value, i) => value.person_id === admin.person_id);
          if (person) ret.push(admin.person_id);
        }
      }
      return ret;
    },

    required: function() {
      let req = 0;
      for (let field of this.fields) {
        if (field.required) {
          req++;
        }
      }
      return req;
    },

    assignedAdmins: function() {
      let aa = 0;
      for (let admin of this.admins) {
        if (admin.person_id > 0) {
          aa++;
        }
      }
      return aa;
    }
  },

  mounted() {
    let modals = document.querySelectorAll('.modal');
    window.initMaterializeModals(modals);
  }
}
</script>

<style scoped>
</style>
